import { FieldCheckState } from "./types";

export const initialState: FieldCheckState = {
  items: {},
};
